/**
 * Returned – PDP-modul (laddas bara på produktsidor)
 *  1. Sticky köp-bar på mobil (visas när köpknappen scrollats förbi)
 *  2. Lagervarning som läser exakt lagersaldo per vald variant
 *  3. "Fler räddade fynd från [vendor]"-rad via predictive search
 */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;

  var form = document.querySelector('form.product-form[action*="/cart/add"], form[action*="/cart/add"]');
  var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  var moneyFormat = (window.RTD_CART_SETTINGS && window.RTD_CART_SETTINGS.moneyFormat) || '{{amount_no_decimals}} kr';

  function formatMoney(cents) {
    function fmt(n, precision) {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    }
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount_no_decimals';
    var value = key.indexOf('no_decimals') > -1 ? fmt(cents, 0) : fmt(cents, 2);
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  function currentVariantId() {
    if (!form) return null;
    var checked = form.querySelector('[name="id"]:checked');
    if (checked) return checked.value;
    var el = form.querySelector('[name="id"]');
    return el ? el.value : null;
  }

  /* ------------------------------------------ produktdata (en hämtning) */

  var productData = null;
  var productReady = handle
    ? fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { productData = p; return p; }).catch(function () { return null; })
    : Promise.resolve(null);

  function variantById(id) {
    if (!productData) return null;
    id = parseInt(id, 10);
    return productData.variants.filter(function (v) { return v.id === id; })[0] || null;
  }

  /* --------------------------------- 2. lagervarning (exakt per variant) */

  var urgencyHost = document.querySelector('[data-rtd-pdp-urgency]');
  var invData = {};
  (function () {
    var el = document.querySelector('[data-rtd-inventory-json]');
    if (el) { try { invData = JSON.parse(el.textContent); } catch (e) {} }
  })();

  function updateUrgency() {
    if (!urgencyHost) return;
    var vid = currentVariantId();
    var d = invData[vid];
    var threshold = parseInt(urgencyHost.dataset.threshold, 10) || 3;
    // Visa bara när Shopify spårar lagret, varianten inte tillåter översäljning,
    // och saldot är 1..threshold — annars dölj (= aldrig fel siffra).
    if (d && d.m === 'shopify' && d.p !== 'continue' && d.q > 0 && d.q <= threshold) {
      var text = d.q === 1
        ? (urgencyHost.dataset.textOne || 'Endast 1 i lager – sen är den borta')
        : (urgencyHost.dataset.textFew || 'Endast [antal] kvar i lager').replace('[antal]', d.q);
      urgencyHost.querySelector('[data-rtd-urgency-text]').textContent = text;
      urgencyHost.hidden = false;
    } else {
      urgencyHost.hidden = true;
    }
  }

  /* --------------------------------------- 1. sticky köp-bar (mobil) */

  var stickyBar = null;

  function injectStickyStyles() {
    if (document.getElementById('rtd-sticky-styles')) return;
    var css =
      '.rtd-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:99990;background:#fff;border-top:1px solid rgba(0,0,0,.12);box-shadow:0 -4px 16px rgba(0,0,0,.08);padding:10px 16px calc(10px + env(safe-area-inset-bottom));display:flex;align-items:center;gap:12px;transform:translateY(110%);transition:transform .25s cubic-bezier(.25,.46,.45,.94);}' +
      '.rtd-sticky-atc.is-visible{transform:translateY(0);}' +
      '.rtd-sticky-atc__info{min-width:0;flex:1 1 auto;}' +
      '.rtd-sticky-atc__title{display:block;font-size:13px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
      '.rtd-sticky-atc__price{font-size:14px;font-weight:700;color:var(--rtd-sale,#bf262f);}' +
      '.rtd-sticky-atc__price s{color:var(--rtd-ink-soft,#464646);font-weight:400;font-size:12px;margin-right:6px;}' +
      '.rtd-sticky-atc__btn{flex:0 0 auto;appearance:none;border:0;border-radius:4px;background:var(--rtd-primary,#076633);color:#fff;font-size:15px;font-weight:600;padding:14px 22px;cursor:pointer;}' +
      '.rtd-sticky-atc__btn:active{transform:scale(.98);}' +
      '.rtd-sticky-atc__btn[disabled]{background:#ccc;cursor:not-allowed;}' +
      '@media (min-width:860px){.rtd-sticky-atc{display:none;}}';
    var s = document.createElement('style');
    s.id = 'rtd-sticky-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function updateStickyPrice() {
    if (!stickyBar) return;
    var v = variantById(currentVariantId());
    var priceHost = stickyBar.querySelector('[data-rtd-sticky-price]');
    if (!v || !priceHost) return;
    priceHost.innerHTML =
      (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '') +
      formatMoney(v.price);
    var btn = stickyBar.querySelector('[data-rtd-sticky-add]');
    if (btn) {
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Lägg i varukorg' : 'Slutsåld';
    }
  }

  function initStickyBar() {
    if (!form) return;
    var atcBtn = form.querySelector('[type="submit"], .custom-add-to-cart-btn');
    if (!atcBtn) return;

    injectStickyStyles();
    stickyBar = document.createElement('div');
    stickyBar.className = 'rtd-sticky-atc';
    stickyBar.setAttribute('aria-hidden', 'true');
    stickyBar.innerHTML =
      '<div class="rtd-sticky-atc__info">' +
        '<span class="rtd-sticky-atc__title">' + ((productData && productData.title) || document.title) + '</span>' +
        '<span class="rtd-sticky-atc__price" data-rtd-sticky-price></span>' +
      '</div>' +
      '<button type="button" class="rtd-sticky-atc__btn" data-rtd-sticky-add>Lägg i varukorg</button>';
    document.body.appendChild(stickyBar);
    updateStickyPrice();

    stickyBar.querySelector('[data-rtd-sticky-add]').addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        // Visa baren när köpknappen lämnat viewporten uppåt
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(atcBtn);
    }
  }

  /* ------------------------- 3. "Fler räddade fynd från [vendor]"-rad */

  function initVendorRow() {
    var row = document.querySelector('[data-rtd-vendor-row]');
    if (!row) return;
    var vendor = row.dataset.vendor;
    if (!vendor) return;

    var url = '/search/suggest.json?q=' + encodeURIComponent('"' + vendor + '"') +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=vendor';

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var products = (((data || {}).resources || {}).results || {}).products || [];
        products = products.filter(function (p) {
          return (p.url || '').indexOf('/products/' + handle) === -1;
        }).slice(0, 8);

        if (!products.length) { row.hidden = true; return; }

        var list = row.querySelector('[data-rtd-vendor-list]');
        products.forEach(function (p) {
          var pHandle = ((p.url || '').match(/\/products\/([^\/?#]+)/) || [])[1];
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          if (img) img = img.split('?')[0] + '?width=360';
          var priceCents = Math.round(parseFloat(p.price || '0') * 100);

          var card = document.createElement('div');
          card.className = 'rtd-vrow__card';
          card.innerHTML =
            '<a class="rtd-vrow__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy" width="180" height="225">' : '') +
            '</a>' +
            '<a class="rtd-vrow__title" href="' + p.url + '">' + p.title + '</a>' +
            '<span class="rtd-vrow__price">' + formatMoney(priceCents) + '</span>' +
            (pHandle ? '<button type="button" class="rtd-card-add rtd-vrow__add" data-rtd-quick-pick="' + pHandle + '">Lägg i varukorg</button>' : '');
          list.appendChild(card);
        });
        row.hidden = false;
      })
      .catch(function () { row.hidden = true; });
  }

  /* ------------------------------------------------------------- init */

  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        updateUrgency();
        updateStickyPrice();
      }
    });
  }

  updateUrgency();
  productReady.then(function () { initStickyBar(); });
  initVendorRow();
})();
